import HttpClient from '../../adapter/HttpClient';

class AuthenticationWebApi {
  private httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public signOut = async (): Promise<void> => {
    await this.httpClient.delete(`/authentication_token`, {});
  };
}

export default AuthenticationWebApi;
